import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { LanguageService } from '../language-service/language.service';
import { TokenService } from '../token-service/token.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private languageService: LanguageService,
    public translate: TranslateService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isAssetRequest =
      request.url.includes('/assets/') ||
      request.url.startsWith('assets/') ||
      request.url.endsWith('.json');

    // Δεν πειράζουμε καθόλου assets/translations
    if (isAssetRequest) {
      return next.handle(request);
    }

    const token = request.url.endsWith('token')
      ? null
      : this.tokenService.getToken();

    const language = this.languageService.getLanguageFromLocalStorage();

    const headers: Record<string, string> = {};

    if (token) {
      headers['Authorization'] = token;
    }

    if (language) {
      headers['Accept-Language'] = language;
    }

    return next.handle(
      request.clone({
        setHeaders: headers,
      })
    );
  }
}
